module.exports = __webpack_public_path__ + "img/dentist-about-us.1ec6ccf7.jpg";